"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "color", {
  enumerable: true,
  get: function get() {
    return _colorResolver["default"];
  }
});
Object.defineProperty(exports, "typography", {
  enumerable: true,
  get: function get() {
    return _typographyResolver["default"];
  }
});
exports["default"] = exports.DEPTH = exports.BORDER_RADIUS = exports.Z_INDICES = exports.SIZES = exports.SPACING = exports.FIELD_HEIGHTS = void 0;

var _colors = _interopRequireDefault(require("./colors"));

var _colorResolver = _interopRequireDefault(require("./colorResolver"));

var _typographyResolver = _interopRequireDefault(require("./typographyResolver"));

var _weights = require("./fonts/weights");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * FIELD_HEIGHTS are used to ensure buttons, inputs, selects and the like all
 * use consistent heights if put on a horizontal line
 */


var FIELD_HEIGHTS = {
  REGULAR: '40px',
  LARGE: '60px',
  SMALL: '32px'
};
exports.FIELD_HEIGHTS = FIELD_HEIGHTS;
var SPACING = {
  L1: '4px',
  L2: '8px',
  L3: '12px',
  L4: '16px',
  L5: '24px',
  L6: '32px',
  L7: '48px',
  L8: '64px',
  L9: '96px',
  L10: '160px'
}; // Standard sizes used for component sizing

exports.SPACING = SPACING;
var SIZES = Object.freeze({
  XSMALL: 'xsmall',
  SMALL: 'small',
  REGULAR: 'regular',
  REGULAR2: 'regular2',
  LARGE: 'large',
  XLARGE: 'xlarge',
  XXLARGE: 'xxlarge'
}); // z-index list based on NAME, this is easier to manage

exports.SIZES = SIZES;
var Z_INDICES = {
  card: 100,
  dialog: 200,
  sidenav: 300,
  topnav: 310,
  layer: 400,
  blanket: 500,
  modal: 510,
  flag: 600,
  spotlight: 700,
  tooltip: 800
};
exports.Z_INDICES = Z_INDICES;
var BORDER_RADIUS = 3;
exports.BORDER_RADIUS = BORDER_RADIUS;
var DEPTH = {
  RAISED: {
    boxShadow: '-3px 0px 4px -3px rgba(0, 0, 0, 0.1), 3px 0px 4px -3px rgba(0, 0, 0, 0.1), 0px 3px 4px -3px rgba(0, 0, 0, 0.1)'
  },
  OVERLAY: {
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.1)'
  },
  FIXED: {
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.1)'
  },
  FLOAT: {
    boxShadow: '0px 6px 16px 0px rgba(0, 0, 0, 0.1)'
  }
};
exports.DEPTH = DEPTH;
/** @component */

var _default = {
  color: _colorResolver["default"],
  BORDER_RADIUS: BORDER_RADIUS,
  COLORS: _colors["default"],
  DEPTH: DEPTH,
  FONT_WEIGHTS: _weights.FONT_WEIGHTS,
  SPACING: SPACING,
  typography: _typographyResolver["default"],
  Z_INDICES: Z_INDICES
};
exports["default"] = _default;